/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createUser } from '../fn/user/create-user';
import { CreateUser$Params } from '../fn/user/create-user';
import { findUsers } from '../fn/user/find-users';
import { FindUsers$Params } from '../fn/user/find-users';
import { FindUsersResponseDto } from '../models/find-users-response-dto';
import { getUser } from '../fn/user/get-user';
import { GetUser$Params } from '../fn/user/get-user';
import { patchUser } from '../fn/user/patch-user';
import { PatchUser$Params } from '../fn/user/patch-user';
import { UserInfoDto } from '../models/user-info-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findUsers()` */
  static readonly FindUsersPath = '/api/users';

  /**
   * Finds users by a given filter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  findUsers$Response(params: FindUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<FindUsersResponseDto>> {
    return findUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds users by a given filter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findUsers(params: FindUsers$Params, context?: HttpContext): Observable<FindUsersResponseDto> {
    return this.findUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindUsersResponseDto>): FindUsersResponseDto => r.body)
    );
  }

  /** Path part for operation `createUser()` */
  static readonly CreateUserPath = '/api/users';

  /**
   * Creates an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createUser$Response(params: CreateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInfoDto>> {
    return createUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createUser(params: CreateUser$Params, context?: HttpContext): Observable<UserInfoDto> {
    return this.createUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserInfoDto>): UserInfoDto => r.body)
    );
  }

  /** Path part for operation `getUser()` */
  static readonly GetUserPath = '/api/users/{id}';

  /**
   * Gets an users by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser$Response(params: GetUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInfoDto>> {
    return getUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an users by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUser(params: GetUser$Params, context?: HttpContext): Observable<UserInfoDto> {
    return this.getUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserInfoDto>): UserInfoDto => r.body)
    );
  }

  /** Path part for operation `patchUser()` */
  static readonly PatchUserPath = '/api/users/{id}';

  /**
   * Patches an user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchUser()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchUser$Response(params: PatchUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserInfoDto>> {
    return patchUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches an user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchUser$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchUser(params: PatchUser$Params, context?: HttpContext): Observable<UserInfoDto> {
    return this.patchUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserInfoDto>): UserInfoDto => r.body)
    );
  }

}
